module.exports = function() {
  return new Worker(__webpack_public_path__ + "408e0b0141fc7be30549.worker.js");
};